/* eslint-disable jsx-a11y/click-events-have-key-events */

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { CamIcon, Chevron, SurfHeight } from '@surfline/quiver-react';
import { slugify } from '@surfline/web-common';
import unitsPropType from '../../propTypes/units';
import spotPropType from '../../propTypes/spot';
import conditionClassModifier from '../../utils/conditionClassModifier';
import en from '../../intl/translations/en';

const getConditionsClassName = (conditions, expired) =>
  classNames({
    'sl-forecast-header-menu__nearby-spot__details__conditions': true,
    [`sl-forecast-header-menu__nearby-spot__details__conditions--${conditionClassModifier(
      conditions
    )}`]: true,
    'sl-forecast-header-menu__nearby-spot__details__conditions--expired': expired,
  });

const NearbySpots = ({
  className,
  title,
  units,
  nearbySpots,
  chevronDirection,
  pathGenerator,
  onClickLink,
  onClick,
}) => (
  <div className={className} onClick={onClick}>
    <div className="sl-forecast-header-menu__dropdown__title">
      {title} <Chevron direction={chevronDirection} />
    </div>
    <div className="sl-forecast-header-menu__nearby-spots">
      {nearbySpots.map(spot => {
        const isMultiCam = spot.cameras && spot.cameras.length > 1;
        /* TODO add react-router paths for spot forecast pages */
        return (
          <Link
            key={spot._id}
            title={`${spot.name} ${en.SpotPage.header.titleSuffix}`}
            className="sl-forecast-header-menu__nearby-spot"
            to={pathGenerator(slugify(spot.name), spot._id)}
            onClick={() => onClickLink(spot)}
          >
            {spot.conditions ? (
              <div className="sl-forecast-header-menu__nearby-spot__details">
                <span
                  className={getConditionsClassName(
                    spot.conditions.value,
                    spot.conditions.expired && spot.conditions.human
                  )}
                />
                <span className="sl-forecast-header-menu__nearby-spot__details__name">
                  {spot.name}
                </span>
              </div>
            ) : (
              <span className="sl-forecast-header-menu__nearby-spot__details__name">
                {spot.name}
              </span>
            )}
            {spot.cameras && spot.cameras.length ? (
              <span className="sl-forecast-header-menu__nearby-spot__icon">
                <CamIcon isMultiCam={isMultiCam} withText />
              </span>
            ) : null}
            {spot.waveHeight ? (
              <SurfHeight
                min={spot.waveHeight.min}
                max={spot.waveHeight.max}
                units={units.surfHeight}
              />
            ) : null}
          </Link>
        );
      })}
    </div>
  </div>
);

NearbySpots.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  units: unitsPropType.isRequired,
  nearbySpots: PropTypes.arrayOf(spotPropType).isRequired,
  chevronDirection: PropTypes.oneOf(['down', 'up']).isRequired,
  pathGenerator: PropTypes.func.isRequired,
  onClickLink: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

NearbySpots.defaultProps = {
  className: null,
};

export default NearbySpots;
